export default {
    manage_deletedInput: "Etiqueta de Entrada eliminada",
    manage_deletedInputs: "Etiquetas de Entrada eliminadas",
    manage_deleteManageInput_deleteInput: "Eliminar Etiqueta de Entrada",
    manage_deleteManageInput_deleteInputs: "Eliminar Etiquetas de Entrada",
    manage_deleteManageInput_confirmationMessage:
    "¿Estás seguro que deseas eliminar las siguientes Etiquetas de Entrada?",
}